import React from 'react';
import classnames from 'classnames';
import Html from 'Shared/Partials/PropertyTypes/Html';
import * as styles from './base.scss';
export default class Info extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        const html = this.props.text ? this.props.text || this.props.text.html : [];
        return (React.createElement("div", null,
            React.createElement("div", { className: classnames(styles.base, {}) },
                React.createElement("div", { className: styles.description }, typeof html === 'string' ? html : React.createElement(Html, { tagName: "div", html: html })))));
    }
}
